<div *ngIf="control.invalid && (control.dirty || control.touched)">
  <div *ngIf="control.errors!['required']" class="ui-messages-error">{{label}} is required</div>
  <div *ngIf="control.errors!['min']" class="ui-messages-error">{{label}} should not be negative</div>
  <div *ngIf="control.errors!['maxlength']" class="ui-messages-error">{{label}} should be less than {{control.errors!['maxlength'].requiredLength}} characters</div>
  <div *ngIf="control.dirty && control.errors!['inValidEmail']" class="ui-messages-error">{{label}} should be valid </div>
</div>
